var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCaledario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 55,
    viewBox: "0 0 50 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H33.75V37.05L39.85 40.575L37.975 43.825L30 39.225V30ZM40 17.5H5V45H16.675C15.6 42.725 15 40.175 15 37.5C15 32.8587 16.8437 28.4075 20.1256 25.1256C23.4075 21.8437 27.8587 20 32.5 20C35.175 20 37.725 20.6 40 21.675V17.5ZM5 50C3.67392 50 2.40215 49.4732 1.46447 48.5355C0.526784 47.5978 0 46.3261 0 45V10C0 7.225 2.225 5 5 5H7.5V0H12.5V5H32.5V0H37.5V5H40C41.3261 5 42.5979 5.52678 43.5355 6.46447C44.4732 7.40215 45 8.67392 45 10V25.25C48.1 28.4 50 32.725 50 37.5C50 42.1413 48.1563 46.5925 44.8744 49.8744C41.5925 53.1562 37.1413 55 32.5 55C27.725 55 23.4 53.1 20.25 50H5ZM32.5 25.375C29.2843 25.375 26.2002 26.6524 23.9263 28.9263C21.6525 31.2002 20.375 34.2842 20.375 37.5C20.375 44.2 25.8 49.625 32.5 49.625C34.0923 49.625 35.669 49.3114 37.14 48.702C38.6111 48.0927 39.9478 47.1996 41.0737 46.0737C42.1996 44.9478 43.0927 43.6111 43.702 42.14C44.3114 40.669 44.625 39.0923 44.625 37.5C44.625 30.8 39.2 25.375 32.5 25.375Z",
    fill: "#F7F2EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCaledario);
export default __webpack_public_path__ + "static/media/ic_caledario.04f9fd5e404d04cc6241eeae6d696688.svg";
export { ForwardRef as ReactComponent };